/**
 * Per-browser pairing session helpers.
 * Each Connect click gets a unique client_session_id so status polls never
 * inherit another tab/browser's pairing attempt.
 */
export function newPairingClientSessionId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `pcs_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}
